/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import React from 'react';
import { redirect, type RouteObject } from 'react-router-dom';

import { defaultChatModelId } from '@fai/friendli-suite/features/products/serverless-endpoints/chat-mock-data/mock-data';
import { redirectToLandingIfPlanInaccessible } from '@fai/friendli-suite/features/routes/loaders/product/serverless-endpoints';
import { redirectToModelIfPlanAccessible } from '@fai/friendli-suite/features/routes/loaders/product/serverless-endpoints/check-serverless-endpoints-accessibility';
import { pipeLoaders } from '@fai/third-party/react-router-dom';
import { redirectIfSessionExpired } from '@fai/third-party/supertokens';

const LandingPage = React.lazy(
  () => import('@fai/friendli-suite/pages/serverless-endpoints/landing')
);
// const CompletionPage = React.lazy(
//   () =>
//     import('@fai/friendli-suite/pages/serverless-endpoints/model/completion')
// );
const ChatPage = React.lazy(
  () => import('@fai/friendli-suite/pages/serverless-endpoints/model/chat')
);
// const ImageGenerationPage = React.lazy(
//   () =>
//     import(
//       '@fai/friendli-suite/pages/serverless-endpoints/model/image-generation'
//     )
// );

// Model detail routes are under serverlessEndpointsRoutes, but not using layout.
// So this routes should be excluded from ProductBasicLayout.
export const serverlessEndpointsModelDetailRoutes = [
  {
    path: 'chat/:modelId',
    Component: ChatPage,
  },
  {
    path: '*',
    loader: () => redirect(`chat/${defaultChatModelId}`),
  },
  // {
  //   path: 'completion/:modelId',
  //   Component: CompletionPage,
  // },
  // {
  //   path: 'image-generation/:modelId',
  //   Component: ImageGenerationPage,
  // },
];

const serverlessEndpointsRoutes: RouteObject[] = [
  {
    path: 'landing',
    loader: pipeLoaders({
      sequence: [redirectIfSessionExpired, redirectToModelIfPlanAccessible],
    }),
    children: [{ index: true, Component: LandingPage }],
  },
  {
    path: 'model',
    loader: pipeLoaders({
      sequence: [redirectIfSessionExpired, redirectToLandingIfPlanInaccessible],
    }),
    children: [
      {
        index: true,
        // FIXME: need default redirection path, temporary redirect to chat model
        loader: () => redirect(`chat/${defaultChatModelId}`),
      },
    ],
  },
  {
    path: '*',
    loader: () => redirect('model'),
  },
];

export default serverlessEndpointsRoutes;
